import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { newsletterUnsubscribe } from '../../services/api';
import { newsletterEvents, userEvents } from '../../utils/analytics';
import './UnsubForm.css';

const UnsubForm = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState({ type: '', message: '' });
  const [loading, setLoading] = useState(false);

  const handleUnsubscribe = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: '', message: '' });

    try {
      await newsletterUnsubscribe(email);
      setStatus({
        type: 'success',
        message: 'Successfully unsubscribed from the newsletter!'
      });
      setEmail('');
      newsletterEvents.unsubscribe('user_initiated');
      userEvents.formSubmit('newsletter_unsubscribe', true);
    } catch (error) {
      const errorMessage = error.response?.data?.detail || error.message || 'Failed to unsubscribe. Please try again.';
      setStatus({
        type: 'error',
        message: errorMessage
      });
      userEvents.formSubmit('newsletter_unsubscribe', false);
      userEvents.error('newsletter_unsubscribe', errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="unsub-form component-card">
        <h2 className="subtitle">Unsubscribe</h2>
        <p className="text">
          We're sorry to see you go. Enter your email below to unsubscribe from our newsletter.
        </p>
        
        <form onSubmit={handleUnsubscribe}>
          <div className="unsub-form-group">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
              disabled={loading}
            />
          </div>
          <button 
            type="submit" 
            className="btn-primary"
            disabled={loading}
          >
            {loading ? 'Unsubscribing...' : 'Unsubscribe'}
          </button>
          {status.message && (
            <div className={`status-message ${status.type}`}>
              {status.message}
            </div>
          )}
        </form>
        
        <div className="disclaimer">
          Back to <Link to="/" className="page-link">home</Link> to resubscribe anytime.
        </div>
      </div>
  );
};

export default UnsubForm;
